<script setup lang="ts">
  import AddonTooltip from '@/shared/components/AddonTooltip/AddonTooltip.vue'

  interface Props {
    info: string | string[]
    size?: number
    color?: string
  }

  withDefaults(defineProps<Props>(), {
    size: 16,
    color: '#394B5A',
  })
</script>

<template>
  <AddonTooltip
    v-if="info"
    label=""
    amount=""
    :info="info"
    :size="size"
    :color="color"
    :tooltip-timeout="10"
    class="tooltip"
  >
    <template v-if="Array.isArray(info)" #tooltip-content>
      <ul class="tooltip-list-content">
        <li v-for="item in info" :key="item">
          {{ item }}
        </li>
      </ul>
    </template>
  </AddonTooltip>
</template>

<style lang="scss" scoped>
  @use '@/shared/assets/styles/utils' as *;

  .tooltip {
    display: inline-flex;
    margin-inline-start: var(--spacing-2);
    vertical-align: sub;
  }

  :deep(.addon-tooltip__popup) {
    max-width: 280px;
    top: 24px;

    &::after {
      bottom: unset;
      top: -5px;
      transform: rotate(135deg);
    }
  }

  :deep(.addon-tooltip__info-icon-wrapper .addon-tooltip__info-icon path) {
    fill-opacity: 1;
  }

  .tooltip-list-content {
    list-style-type: disc;

    /* qic-connect-ignore-next-line */
    padding-left: 1.2em;
    text-align: left;
  }
</style>
